import { FC, useEffect } from "react";
import gsap from "gsap";
import { BaseProps } from "./text";
import GText from "./GText";
import useScrollTrigger from "../../functions/useScrollTrigger";
import { css } from "@emotion/react";

interface Props {
  text?: string;
  once?: boolean;
  duration?: number;
}

const GTextFadeIn: FC<Props & BaseProps> = (props) => {
  const styles = css`
    margin: 0;
  `;

  const { ref } = useScrollTrigger(() => {
    if (!props.once) {
      resetEffect();
    }

    gsap.to(ref.current, {
      scale: 1,
      duration: 3,
      ease: gsap.parseEase("cubic-bezier(0.5, 1, 0.89, 1)"),
    });

    gsap.to(ref.current?.children as gsap.TweenTarget, {
      opacity: 1,
      filter: "blur(0px)",
      duration: 0.8,
      stagger: 0.1,
      ease: gsap.parseEase("cubic-bezier(0.11, 0, 0.5, 0)"),
    });
  });

  useEffect(() => {
    if (props.once) {
      resetEffect();
    }
  }, []);

  const resetEffect = () => {
    gsap.set(ref.current, { transformOrigin: "center", scale: 0.94 });
    gsap.set(ref.current?.children as gsap.TweenTarget, {
      opacity: 0,
      filter: "blur(4px)",
      display: "inline-block",
      whiteSpace: "pre",
    });
  };

  const splitTextIntoSpan = () => {
    return props.text?.split("").map((l, i) => <span key={i}>{l}</span>);
  };

  return (
    <GText {...props}>
      <h1 ref={ref} css={styles}>
        {splitTextIntoSpan()}
      </h1>
    </GText>
  );
};

GTextFadeIn.defaultProps = {
  text: "Subscribe to grooody",
  color: "#000",
  once: true,
  fontSize: 12,
};

export default GTextFadeIn;

// We need to add the below in framer
/*
addPropertyControls(TextFadeIn, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Subscribe to Grooody",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    color: {
        title: "Color",
        type: ControlType.Color,
        defaultValue: "#000",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 46,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Sigmar",
    },
    once: {
        title: "Once",
        type: ControlType.Boolean,
        defaultValue: true,
        description: "Run animation only once on page mount",
    },
})


*/
